<template>
  <modal
    name="tutorialVideoPopup"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :classes="['custom']"
    :clickToClose="false"
    :width="664"
    :height="510"
    :min-height="510"
  >
    <div class="container" v-if="openedTutorial">
      <div class="heading">
        {{openedTutorial.title}}
        <div class="close icon-popup-close" @click="close"></div>
      </div>
      <video class="video" :src="videoUrl" autoplay controls></video>
      <div class="footer">
        <div class="btn" @click="close">知道了</div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      openedTutorial: 'helpCenter/openedTutorial'
    }),
    videoUrl () {
      return this.$handleAssetsUrl(this.openedTutorial ? this.openedTutorial.videoUrl : '');
    }
  },
  methods: {
    beforeOpen () {

    },
    close () {
      this.$modal.hide('tutorialVideoPopup');
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}
.heading {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #F0F0F8;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  font-weight: bold;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 16px;
  margin-bottom: 16px;
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.video {
  width: 600px;
  height: 338px;
  opacity: 1;
  border-radius: 0px;
  border: none;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 32px;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 126px;
  height: 40px;
  background: #5778FB;
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pagePopups/tutorialVideoPopup.vue